<!-- メニューボタン -->
<template>
  <div
    class="crly-a-common-btn-menu"
    :class="{ open: this.isOpen }"
    @click="clickMenuBtn"
  >
    <div class="crly-a-common-btn-menu__inner" />
  </div>
</template>

<script>
export default {
  name: "CrlyAtomsCommonBtnMenu",
  props: {
    /**
     * スライドメニューの表示状態
     */
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickMenuBtn() {
      this.$emit("clickMenuBtn", !this.isOpen);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/atoms/common/btn/menu.scss";
</style>
